import { configurations } from "../interfaces/configurations.interface";

export enum ACTIVITY_STATUS {
    PENDIENTE = 1,
    OBSERVADO = 2,
    APROBADO = 3,
    APROBADO_CLIENTE = 4,
    OBSERVADO_CLIENTE = 5,
    ELIMINADO = 6,
    REVISADO = 7,
    CORREGIDO = 8,
    PENDIENTE_DIRECTOR = 9,
    PENDIENTE_PAGO = 11,
    PAGADO = 10,
}

export enum ACTIVITY_REVISION_STATUS {
    NO_REVISION = 0,
    REVISION = 1,
}

export enum TIME_TYPE {
    HORARIO_REGULAR = 1,
    EXTRAS = 2,
    COMPENSACIÓN = 3,
    AVANCE = 4,
    RECUPERACIÓN = 5,
}

export enum LIST_HOUR_TYPE {
    GRAFICO = 1,
    LISTADO = 2
}

export enum REQUIREMENTS_STATUS {
    ACTIVO = 1,
    INACTIVO = 0,
    PAUSADO = 2,
    COMPLETADO = 3,
    DESESTIMADO = 4,
}

export const TaskExtraHoursOptions: configurations[] = [
  {
    sCodigo: '0',
    sDescripcion: 'SOLO TAREAS SELECCIONADAS',
    sTipo_Configuracion: 'OPCIONES TAREO'
  },
  {
    sCodigo: '1',
    sDescripcion: 'TODAS LAS TAREAS FILTRADAS',
    sTipo_Configuracion: 'OPCIONES TAREO'
  }
]

export const TaskApproveOptions: configurations[] = [
    {
        sCodigo: '0',
        sDescripcion: 'SOLO TAREAS SELECCIONADAS',
        sTipo_Configuracion: 'OPCIONES TAREO'
    },
    {
        sCodigo: '1',
        sDescripcion: 'TODAS LAS TAREAS FILTRADAS',
        sTipo_Configuracion: 'OPCIONES TAREO'
    }
]

export enum STATUS_PAY {
    PENDIENTE_PAGO = 0,
    PAGADO = 1,
}

export enum LIST_TYPE {
    PROYECTO = 1,
    EQUIPO = 0,
}